import { DatePicker } from './DatePicker';
import { WheelDatePicker } from './WheelDatePicker';
import { VFC, useEffect, useState } from 'react';
import { useRouter } from '@raysee/hooks';

export interface Props {
  date: Date;
  isDefault?: boolean;
  isOpen: boolean;
  defaultDate?: Date;
  min: Date;
  max: Date;
  onSelect: (date) => void;
  onCancel: () => void;
  onChange: (date: Date) => void;
}

const MIN_DATE = new Date(1920, 0, 1);
const MAX_DATE = new Date(2010, 11, 31);

export const InputDate: VFC<Omit<Props, 'min' | 'max'>> = ({
  date,
  isDefault = false,
  isOpen,
  defaultDate = new Date(2000, 0, 1),
  onSelect,
  onCancel,
  onChange,
}) => {
  const router = useRouter();
  const [isMobile, setIsMobile] = useState(true);
  const isCounsel = router.pathname.startsWith('/counsel');

  useEffect(() => {
    setIsMobile(/iPhone|Android.+Mobile/.test(navigator.userAgent));
  }, []);

  return (
    <>
      {isMobile || isCounsel ? (
        <WheelDatePicker
          date={date}
          isDefault={isDefault}
          isOpen={isOpen}
          defaultDate={defaultDate}
          min={MIN_DATE}
          max={MAX_DATE}
          onSelect={onSelect}
          onCancel={onCancel}
          onChange={onChange}
        />
      ) : (
        <DatePicker
          date={date}
          isDefault={isDefault}
          isOpen={isOpen}
          defaultDate={defaultDate}
          min={MIN_DATE}
          max={MAX_DATE}
          onSelect={onSelect}
          onCancel={onCancel}
          onChange={onChange}
        />
      )}
    </>
  );
};
